import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const orgComplianceDetailPageContext = React.createContext({});
export let orgComplianceDetailPageMachine: any;

const MODULE_NAME = 'machines.OrgComplianceDetail';

export const useSMOrgComplianceDetailPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  orgComplianceDetailPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(orgComplianceDetailPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    orgComplianceDetailPageMachine,
    orgComplianceDetailPageState: state,
    orgComplianceDetailPageSend: send,
  };
};
